import { useRef, useEffect } from "react";

export default function StationaryWaves() {
  const canvasRef = useRef(null);

  const collapsedTarget = useRef(0); // 0 = expanded, 1 = collapsed
  const collapseProgress = useRef(0);

  const sizeRef = useRef({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    function resize() {
      sizeRef.current.width = window.innerWidth;
      sizeRef.current.height = window.innerHeight;
      canvas.width = sizeRef.current.width;
      canvas.height = sizeRef.current.height;
    }

    resize();
    window.addEventListener("resize", resize);

    let t = 0;

    const omega = 0.015;
    const A = 8;
    const lineCount = 8;
    const ease = 0.08;

    function draw() {
      const { width, height } = sizeRef.current;

      // Smooth interpolation toward target
      collapseProgress.current +=
        (collapsedTarget.current - collapseProgress.current) * ease;

      const p = collapseProgress.current;

      ctx.clearRect(0, 0, width, height);
      ctx.strokeStyle = "#ffffff";
      ctx.lineWidth = 1;

      const spacing = height / (lineCount + 1);
      const centerY = height / 2;

      for (let line = 0; line < lineCount; line++) {
        const yExpanded = spacing * (line + 1);
        const yCollapsed = centerY;

        const yBase = yExpanded * (1 - p) + yCollapsed * p;
        const modes = 2*(line + 1);

        ctx.beginPath();

        for (let x = 0; x <= width; x++) {
          let y = yBase;

          for (let n = 1; n <= modes; n++) {
            const centerWeight = Math.sin((n * Math.PI) / 2);

            y +=
              A *
              centerWeight *
              Math.sin((n * Math.PI * x) / width) *
              Math.cos(n * omega * t);
          }

          if (x === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        }

        ctx.stroke();
      }

      t += 1;
      requestAnimationFrame(draw);
    }

    draw();

    return () => window.removeEventListener("resize", resize);
  }, []);

  useEffect(() => {
    function handleClickCanvas(e) { collapsedTarget.current = collapsedTarget.current === 0 ? 1 : 0; }

    window.addEventListener("click", handleClickCanvas);
    return () => window.removeEventListener("click", handleClickCanvas);
  }, [collapsedTarget]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        inset: 0,
        background: "#0a0a0a",
        cursor: "pointer",
      }}
    />
  );
}
